export function checkAndReplaceGoogleMailWithGmail(input: string): string {
  return input.replace(/@googlemail.com/g, '@gmail.com');
}
